import React from "react";
import { View, Text } from "react-native";

export default function SettingsScreen(): JSX.Element {
  return (
    <View>
      <Text>Settings</Text>
      <View />
    </View>
  );
}
